import React, { Component } from 'react'
import _ from 'lodash'
import update from 'immutability-helper'
import qs from 'qs'
import { bindActionCreators} from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'
import Dls from '../../lib'
import {Breadcrumb, Button, Icon, Segment, Input, Table} from 'semantic-ui-react'
import TableFilter from '../utils/tables/TableFilter'
import TablePagination from '../utils/tables/TablePagination'
import {
    fetchUsers
} from '../../actions/user'

const roleOptions = [
    { key: "Admin", text: "Admin", value: "Admin" },
    { key: "User", text: "User", value: "User" },
    { key: "Disabled", text: "Disabled", value: "Disabled" }
];

class UserSettingPage extends Component {
    constructor() {
        super();
        this.state = {
            routing: {
                params: {
                    on_page: 1,
                    per_page: 15,
                    search: "",
                    filters: {
                        role: "Active"
                    },
                    order_by: {
                        name: "asc"
                    }
                },
                path: ""
            },
            filters: {
                role: []
            },
            filterOpen: true
        };
    }

    componentDidMount() {
        const { params } = this.props.match;
        this.setQueryParamsFromPath(params.params);
    }

    componentWillReceiveProps(props) {
        const { params } = props.match;
        this.setQueryParamsFromPath(params.params);
    }

    setQueryParamsFromPath = path => {
        if (this.state.routing.path !== path) {
            const params = qs.parse(path);
            const { filters } = params;
            let defaultRoleFilter = [];
            if (_.isObject(filters)) {
                if (filters.role) {
                    defaultRoleFilter = filters.role.split(",");
                }
            }

            this.setState({
                routing: { params, path },
                filters: {
                    role: defaultRoleFilter
                }
            }, () => {
                this.fetchRecrods();
            });
        }
    };

    fetchRecrods = () => {
        const {jwt} = this.props;
        const {params} = this.state.routing;
        this.props.fetchUsers(jwt, qs.stringify(params));
    }

    runSearch = () => {
        this.setState({
            routing: {
                params: update(this.state.routing.params, {
                    on_page: { $set: 1 }
                })
            }
        }, () => {
            this.routeTo();
        });
    }

    routeTo = () => {
        this.props.history.push(`/settings/users/${qs.stringify(this.state.routing.params)}`);
    }

    _handleKeyPress = e => {
        if (e.key === "Enter") {
            this.runSearch();
        }
    };

    _onSearchChange = e => {
        this.setState({
            routing: {
                params: update(this.state.routing.params, {
                    search: { $set: e.target.value }
                })
            }
        });
    };

    _onRoleDropdownSelectChange = (e, data) => {
        const { value } = data;
        this.setState({
            filters: update(this.state.filters, {
                role: { $set: value }
            })
        });
        this.setState({
            routing: update(this.state.routing, {
                params: {
                    filters: {
                        role: {$set: value.join()}
                    }
                }
            })
        })
    };

    goToPage = (page) => {
        this.setState({
            routing: {
                params: update(this.state.routing.params, {
                    on_page: { $set: page }
                })
            }
        }, () => {
            this.routeTo();
        });
    }
    //access router
    //this.props.history.push('/dashboard')
    
    render() {
        const {list} = this.props;
        return (
            <div>
                <div className="row" style={{ marginBottom: "5px" }}>
                    <div className="col-md-8">
                        <Breadcrumb size="huge">
                            <Breadcrumb.Section>
                                Settings
                            </Breadcrumb.Section>
                            <Breadcrumb.Divider />
                            <Breadcrumb.Section>
                                <Link
                                    to={`/settings/users/${Dls.pagination.users()}`}
                                >
                                    Users
                                </Link>
                            </Breadcrumb.Section>
                        </Breadcrumb>
                    </div>
                    <div className="col-md-4">
                        <div style={{ float: "right" }}>
                            <Button size="mini" color="teal" icon as={Link} to='/settings/users/new/show'>
                                <Icon name="user" />&nbsp;
                                Create
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="row" style={{ marginBottom: "5px" }}>
                    <div className="col-md-12">
                        <Segment>
                            <div className="col-md-12">
                                <Input
                                    placeholder="Search name or email"
                                    size="mini"
                                    action
                                    onKeyPress={this._handleKeyPress}
                                    onChange={this._onSearchChange}
                                    value={this.state.routing.params.search}
                                    fluid
                                >
                                    <input />
                                    <Button
                                        icon="filter"
                                        onClick={() => {this.runSearch()}}
                                        type="button"
                                        color="pink"
                                    />
                                </Input>
                            </div>
                            <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-6" style={{ marginTop: "5px" }}>
                                    <TableFilter
                                        name="Status"
                                        options={roleOptions}
                                        selectedValues={
                                            this.state.filters.role
                                        }
                                        onDropdownSelectChange={(e, data) => {
                                            this._onRoleDropdownSelectChange(
                                                e,
                                                data
                                            );
                                        }}
                                        placeHolder="Filter by user role"
                                    />
                                </div>
                            </div>
                            </div>
                        </Segment>
                    </div>
                </div>
            
                <div className="row">
                    <div className="col-md-12">
                        <Table compact>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Role</Table.HeaderCell>
                                    <Table.HeaderCell>Name</Table.HeaderCell>
                                    <Table.HeaderCell>Email</Table.HeaderCell>
                                    <Table.HeaderCell>Edit</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {_.isArray(list.data) ? list.data.map(i => {
                                    return <Table.Row key={i.id}>
                                        <Table.Cell>
                                            {i.role}
                                        </Table.Cell>
                                        <Table.Cell>{i.name}</Table.Cell>
                                        <Table.Cell>
                                            {i.email}
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Link to={`/settings/users/${i.id}/show`}>Edit</Link>
                                        </Table.Cell>
                                    </Table.Row>
                                }) : null}
                            </Table.Body>
                        </Table>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12" style={{marginTop: '5px'}}>
                        <TablePagination 
                            goToPage={(page) => {this.goToPage(page);}}
                            on_page={list.on_page} 
                            total_records={list.total_count} 
                            per_page={list.per_page} />
                    </div>
                </div>
            </div>
        )
    }
}

UserSettingPage.propTypes = {
    history: PropTypes.shape({
       push: PropTypes.func.isRequired
    }).isRequired,
    fetchUsers: PropTypes.func.isRequired,
    list: PropTypes.object.isRequired,
    jwt: PropTypes.string.isRequired
};

function mapStateToProps(state) {
    return {
        jwt: state.auth.jwt,
        list: state.user.list
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        fetchUsers
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(UserSettingPage)


// WEBPACK FOOTER //
// ./src/components/settings/User.js